import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Autoplay, Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initGridOfGeneralFullCards() {
  Alpine.data(
    'gridOfGeneralFullCards',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperEl = this.$el.querySelector('.sw-generalFullcards');
        if (swiperEl) {
          this.initSwiper(swiperEl as HTMLElement);
        }
      },
      initSwiper(domEl) {
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          spaceBetween: 0,
          loop: true,
          centeredSlides: false,
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .swiper-button-next`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .swiper-button-prev`,
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
              centeredSlides: true,
              autoHeight: true,
              direction: 'horizontal',
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
              direction: 'horizontal',
            },
            992: {
              slidesPerView: 'auto',
              direction: 'vertical',
            },
          },
        });
      },
    }),
  );
}
